import { render, staticRenderFns } from "./AuditInvoice.vue?vue&type=template&id=64c3fc1a&scoped=true"
import script from "./AuditInvoice.vue?vue&type=script&lang=js"
export * from "./AuditInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3fc1a",
  null
  
)

export default component.exports